import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Input } from "./ContactForm";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const u = await login(email, password);
      navigate(["admin", "super_admin"].includes(u.role) ? "/admin" : "/mis-reportes");
    } catch (e) {
      if (!e.response) {
        setError("No se pudo conectar con el servidor. Verifica tu conexión e intenta nuevamente.");
      } else if (e.response.status === 401) {
        setError("Correo o contraseña incorrectos.");
      } else if (e.response.status === 403) {
        setError("Tu cuenta está bloqueada. Contacta al equipo.");
      } else if (e.response.status === 429) {
        setError("Demasiados intentos. Espera unos minutos e intenta de nuevo.");
      } else if (e.response.status >= 500) {
        setError("No se pudo iniciar sesión por un problema temporal. Intenta nuevamente.");
      } else {
        setError(formatApiError(e.response?.data?.detail));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto space-y-6">
      <h1 className="font-heading text-2xl font-bold text-[#0F172A]">Iniciar sesión</h1>
      <form onSubmit={submit} className="space-y-4">
        <Input label="Correo electrónico" testid="login-email" type="email" value={email} onChange={setEmail} required />
        <Input label="Contraseña" testid="login-password" type="password" value={password} onChange={setPassword} required />
        {error && <p className="text-sm text-[#DC2626]" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={submitting} data-testid="login-submit-btn"
          className="w-full h-14 rounded-xl bg-[#1E3A8A] text-white font-semibold hover:bg-[#1E40AF] disabled:opacity-50">
          {submitting ? "Entrando…" : "Entrar"}
        </button>
      </form>
      <p className="text-sm text-[#475569]">¿No tienes cuenta? <Link to="/registro" className="text-[#1E3A8A] font-medium underline" data-testid="login-register-link">Regístrate</Link></p>
    </div>
  );
}
